module.exports = __webpack_public_path__ + "img/cards-right.a82b886f.png";